import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDropzone } from 'react-dropzone'
import UploadIcon from '../../svg/UploadIcon'
import { useNetworkStatus } from '../../utils/networkStatus'
import useScreen from '../../hooks/useScreen'
import useDeviceDetection from '../../hooks/useDeviceDetection'

const UploadImage = () => {
    return (
        <div className="relative">
            <div className="w-10 h-10 object-cover">
                <UploadIcon />
            </div>
        </div>
    )
}

const DragAndDrop = ({ name, setFiles, multiple = true }) => {
    const { isOffline } = useNetworkStatus()
    const { isMobile, isTablet } = useScreen()
    const { isMobileiOS } = useDeviceDetection()
    const isMobileDevice = isMobile || isTablet

    const onDrop = useCallback(acceptedFiles => {
        setFiles([...acceptedFiles])
    })

    const dropZoneOptions = {
        onDrop,
        maxSize: '10485760', // 10 mb
        accept: {
            'image/jpeg': [],
            'image/png': [],
        },
        multiple,
        // When offline and on iOS device, only allow camera capture
        capture:
            isOffline && isMobileDevice && isMobileiOS
                ? 'environment'
                : undefined,
    }

    const { getRootProps, getInputProps } = useDropzone({
        ...dropZoneOptions,
    })

    const showCameraOnly = isOffline && isMobileDevice && isMobileiOS

    return (
        <div
            {...getRootProps()}
            className="cursor-pointer group w-full h-full rounded-2xl border border-dashed bg-grayBackground hover:bg-grayMedium border-grayLines box-border p-6 flex flex-col items-center justify-center"
        >
            <label className="w-full h-auto flex flex-col items-center justify-center cursor-pointer">
                <UploadImage />
                <p className="text-textDarkGray font-medium text-sm mt-4">
                    {showCameraOnly ? (
                        <span className="text-links text-sm font-medium underline">
                            Click to take a photo
                        </span>
                    ) : (
                        <>
                            <span className="text-links text-sm font-medium underline">
                                Click to upload a file
                            </span>{' '}
                            or drag and drop
                        </>
                    )}
                </p>
                <p className="text-textDarkGray text-xs font-normal text-center mt-1 cursor-pointer">
                    {showCameraOnly
                        ? 'Take a photo with your camera'
                        : 'PNG, JPG, GIF up to 10MB'}
                </p>
            </label>
            <input
                {...getInputProps()}
                type="file"
                aria-label="Dropzone File"
                id="uploadFile"
                name={name}
                className="hidden"
                accept="image/*"
                capture={showCameraOnly ? 'environment' : undefined}
            />
        </div>
    )
}

DragAndDrop.propTypes = {
    name: PropTypes.string,
    setFiles: PropTypes.func.isRequired,
    files: PropTypes.array,
    multiple: PropTypes.bool,
}

export default DragAndDrop
